import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PostLogin } from 'src/app/models/user/post-login';
import { ReturnMessage } from 'src/app/models/return-message';
import { LoginResponse } from 'src/app/models/user/login-response';
import { PostFilterFields } from 'src/app/models/shared/post-filter-fields';
import { PostSearch } from 'src/app/models/search/post-search';
import { SearchResults } from 'src/app/models/search/search-results';
import { PostFieldFromGpsGet } from 'src/app/models/search/post-field-from-gps-get';
import { GpsSearchResult } from 'src/app/models/search/gps-search-result';
import { ReturnDashboardItemPayload } from 'src/app/models/dashboard/return-dashboard-item-payload';
import { ReturnDashboardItemsPayload } from 'src/app/models/dashboard/return-dashboard-items-payload';
import { ReturnUserDashboardItemResultPayload } from 'src/app/models/dashboard/return-user-dashboard-item-result-payload';
import { ReturnDashboardItemSettingsPayload } from 'src/app/models/dashboard/return-dashboard-item-settings-payload';
import { PostDashboardItem } from 'src/app/models/dashboard/post-dashboard-item';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private apis = 
  {
    login: 'zmp_user/Login',
    autocompleteUsers: 'zmp_user/AutocompleteUsers',
    search: 'utility/Search',
    getFieldsFromGps: '/utility/GetFieldsFromGps'
  };

  constructor(
    private http: HttpClient
  ) 
  {
  }

  login(postLogin: PostLogin): Observable<ReturnMessage<LoginResponse>> 
  {
    return this.http.post<ReturnMessage<LoginResponse>>(this.apis.login, postLogin);
  }

  autocompleteUsers(data: PostFilterFields): Observable<ReturnMessage<any>> 
  {
    return this.http.post<ReturnMessage<any>>(this.apis.autocompleteUsers, data);
  }

  search(formData: PostSearch): Observable<ReturnMessage<SearchResults>> 
  {
    return this.http.post<ReturnMessage<SearchResults>>(this.apis.search, formData);
  }

  getFieldsFromGps(data: PostFieldFromGpsGet): Observable<ReturnMessage<GpsSearchResult>> 
  {
      return this.http.post<ReturnMessage<GpsSearchResult>>(this.apis.getFieldsFromGps, data);
  }
}
